module.exports = __webpack_public_path__ + "img/seasonal-ending.dd558fe8.png";